import { FullStory, init as initFS } from "@fullstory/browser"
import type { AnalyticsUserDetails, EventNames } from "types/analytics"

const fullstoryBlockedEmails = [
  "test_nr@client.com",
  "test_3rdrail@client.com",
  "test_wagon@client.com",
  "test_rr@routereports.com",
]

const shouldRecordFullstorySession = (email: string) => {
  return (
    email !== "" && !email.includes("@routereports.com") && !fullstoryBlockedEmails.includes(email)
  )
}

export const initFullStory = (userEmail: string, userDetails: AnalyticsUserDetails) => {
  initFS({ orgId: "ZK3Y5" })
  FullStory("setIdentity", { uid: userEmail, properties: userDetails })
}

export const trackEvent = (userEmail: string, eventName: EventNames, params = {}) => {
  if (shouldRecordFullstorySession(userEmail)) {
    FullStory("trackEvent", { name: eventName, properties: params })
  }
}
